import { jsx as _jsx } from "react/jsx-runtime";
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { NODE_ENV } from '../constants/appConstants';
import { appRefsReducer } from './appRefsSlice';
import { appReducer } from './appSlice';
export const store = configureStore({
    reducer: {
        app: appReducer,
        appRefs: appRefsReducer,
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({ immutableCheck: false, serializableCheck: false }),
    devTools: NODE_ENV === 'development',
});
// Development access to store
if (NODE_ENV === 'development') {
    window.store = store;
}
export const AppStoreProvider = (props) => (_jsx(Provider, Object.assign({ store: store }, props)));
